"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEndTimeValidity = getEndTimeValidity;
exports.getLocalizedCurrentTime = getLocalizedCurrentTime;
exports.getStartTimeValidity = getStartTimeValidity;
exports.localtoUtc = localtoUtc;
exports.utcToLocal = utcToLocal;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// truncate timezone offset from any time values passed in
function localtoUtc(timeValue) {
  var utcOffset = timeValue.utcOffset();
  var newTime = _moment.default.utc(timeValue);
  newTime.add(utcOffset, 'minutes');
  return newTime;
}

// truncate timezone offset from any time values passed in
function utcToLocal(timeValue) {
  var utcOffset = timeValue.utcOffset();
  var newTime = _moment.default.utc(timeValue);
  newTime.add(utcOffset, 'minutes');
  return newTime;
}

// get current UTC time, but add local time offset based on input value
function getLocalizedCurrentTime(timeValue) {
  var utcOffset = timeValue.utcOffset();
  var now = _moment.default.utc();
  now.subtract(utcOffset, 'minutes');
  return now.format();
}
function getStartTimeValidity(startTime, endTime) {
  if (!startTime || !endTime) {
    return {
      isValid: false,
      message: !startTime ? 'Must have a start time.' : null
    };
  }

  // provided values are assumed to be in local time
  // so force them to be interpreted in UTC
  var utcStartTime = localtoUtc(startTime);
  var utcEndTime = localtoUtc(endTime);
  if (utcStartTime.isAfter(utcEndTime)) {
    return {
      isValid: false,
      message: 'Start time must be before end time.'
    };
  } else {
    return {
      isValid: true,
      message: null
    };
  }
}
function getEndTimeValidity(startTime, endTime) {
  if (!startTime || !endTime) {
    return {
      isValid: false,
      message: !endTime ? 'Must have an end time.' : null
    };
  }

  // provided values are assumed to be in local time
  // so force them to be interpreted in UTC
  var utcStartTime = localtoUtc(startTime);
  var utcEndTime = localtoUtc(endTime);
  if (utcStartTime.isAfter(utcEndTime)) {
    return {
      isValid: false,
      message: 'End time must be after start time.'
    };
  } else if (endTime.isAfter(getLocalizedCurrentTime(endTime))) {
    return {
      isValid: false,
      message: 'Selected time must not exceed current time.'
    };
  } else {
    return {
      isValid: true,
      message: null
    };
  }
}